import React from "react";
import { Megaphone, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { dismissBetaBanner, useBetaBannerDismissed } from "@/hooks/useBetaBanner";

export function BetaBanner() {
  const dismissed = useBetaBannerDismissed();

  if (dismissed) {
    return null;
  }

  return (
    <div className="flex items-center justify-between gap-2 bg-primary/10 px-4 py-2 text-sm text-foreground">
      <div className="flex items-center gap-2">
        <Megaphone className="h-4 w-4 shrink-0 text-primary" />
        <span>
          Retreevo is in beta. If you run into a bug, please tell us through the support chat in your account menu at
          the bottom left.
        </span>
      </div>
      <Button variant="ghost" size="icon" className="h-7 w-7 shrink-0" onClick={() => dismissBetaBanner()}>
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
}
